import { createAPI, decryptUrl } from '@common'
const requestCommonAPI = function (url, action, config, vconfig) {
  url = decryptUrl(url)
  if (vconfig && vconfig.url) {
    url = vconfig.url + url
    return createAPI(url, action, config, {
      hubForward: true,
      hub: '/e5/hub',
      ...vconfig
    })
  }
  return createAPI(url, action, config, vconfig)
}
export default {
  // 检查分类下是否有线索
  getCheck: (config, vconfig) =>
    requestCommonAPI('customEncryptApiName-1/0w20gpmefs0difdl', 'get', config, vconfig),
  // 读租户列表
  getRRTenants: (config, vconfig) =>
    requestCommonAPI('customEncryptApiName-1/0w20ss0ufobout', 'get', config, vconfig)
}
